import React, { Component } from "react";
import styled from "styled-components";
import arrowBack from "../../assets/images/arrowBack.png";
import { useNavigate } from 'react-router-dom';
const Header =(props)=>  {
  const navigate = useNavigate();
  const onBackButtonClick = () => {
    if (this.props.navigateToContext) {
      props.navigateToContext(this.props.backPage);
    } else {
      navigate(this.props.backPage);
    }
  };

    return (
      <Root zindex={this.props.zindex}>
        {this.props.backButton && (
          <BackButton
            onClick={() => navigate(this.props.backPage)}
          >
            <BackImage src={arrowBack} />
          </BackButton>
        )}
        {this.props.headerText && (
          <HeaderText>{this.props.headerText.toLowerCase()}</HeaderText>
        )}
        {}
      </Root>
    );
  }


export default Header;

Header.defaultProps = {
  closebutton: false,
  headerText: "",
  backButton: true,
};

const Root = styled.div`
  width: 100%;
  height: 5.6rem;
  position: relative;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  z-index:${(props)=>(props.zindex?props.zindex:0)}
`;

const BackButton = styled.div`
  margin-left: 1.6rem;
  margin-top: 1.6rem;
  cursor: pointer;
`;

const BackImage = styled.img`
  width: 2.4rem;
  height: 2.4rem;
`;

const HeaderText = styled.p`
  text-transform: capitalize;
  padding: 1.9rem 2rem 1.9rem 1.4rem;
  font-family: "Inter";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1px;
  text-align: center;
  font-weight: 600;
  color: #436ab2;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
